export const BASE_URL = "http://localhost:8082";

export const API_ENDPOINTS = {
    LOGIN: "/api/auth/login",
    REGISTER: "/api/auth/register",
    REFRESH_TOKEN: "/api/auth/refresh",
    VALIDATE_TENANT: (domain, subdomain) => `/api/subdomain/validate/${domain}/${subdomain}`,
    PREVIEW_REPORT: "/api/report-data/preview",
    DOWNLOAD_REPORT: "/api/report-data/download",
    TRENDS: "/aiml/trends",
    TRENDS_V2: "/aiml/v2/trends",
    TRENDS_V3: "/aiml/v3/trends",
};